<template>
  <!-- 问诊单通用样式 -->
  <div class="record-paper" v-if="formData">
    <div class="card">
      <div class="card-header">
        <h3>线下就诊</h3>
        <span class="date">就诊日期：{{formData.case_time | dateFilter}}</span>
      </div>
      <div class="card-content">
        <div class="baseinfo-item">
          <div class="type">就诊人信息</div>
          <div class="content">
            <div class="patient-info">{{formData.pat_username}}<span>|</span>{{formData.gender | genderFilter}}<span>|</span>{{formData.birthday | ageFilter}}</div>
          </div>
        </div>
        <div class="baseinfo-item">
          <div class="type">就诊科室</div>
          <div class="content">
            <div class="patient-info">{{formData.p_dep_title}} - {{formData.dep_title}}</div>
          </div>
        </div>
        <div class="baseinfo-item">
          <div class="type">线下就诊病历及处方单</div>
          <div class="content">
            <div class="question-image-wrapper">
              <div class="question-image" v-for="(item, index) in formData.case_img" @click="previewImage(formData.case_img,index)"><img :src="item"></div>
            </div>
          </div>
        </div>
        <div class="baseinfo-item" v-if="formData.result_img.length > 0">
          <div class="type">检查结果及报告</div>
          <div class="content">
            <div class="question-image-wrapper">
              <div class="question-image" v-for="(item, index) in formData.result_img" @click="previewImage(formData.result_img,index)"><img :src="item"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览 -->
    <van-image-preview v-model="previewShow" :images="previewImageList" :start-position="imageIndex"></van-image-preview>
  </div>
</template>

<style lang="less" scoped>
  .record-paper{
    padding-top: 4px;
    .card{
      border-radius: 6px;
      background: #FFF;
      overflow: hidden;
      &:not(:first-child){
        margin-top: 12px;
      }
      &.question-card{
        padding: 0 20px;
      }
      .card-header{
        padding: 20px 12px 16px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #FAFAFA;
        border-bottom: 1px solid #F3F3F3;
        h3{
          font-size: 20px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
        }
        .date{
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
      }
      .card-content{
        padding: 20px 16px 0;
        .baseinfo-item{
          margin-bottom: 32px;
          .type{
            font-size: 16px;
            line-height: 16px;
            color: #666;
          }
          .content{
            margin-top: 8px;
            font-size: 14px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
            .patient-info{
              vertical-align: middle;
              span{
                font-size: 12px;
                color: #CCC;
                margin: 0 12px;
                font-weight: normal;
              }
            }
          }
        }
        .question-image-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          margin-bottom: -16px;
          margin-right: -16px;
          .question-image{
            width: 96px;
            height: 96px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #000;
            overflow: hidden;
            border-radius: 4px;
            margin-right: 16px;
            margin-bottom: 16px;
            img{
              width: 100%;
            }
          }
        }
      }
      .question-header{
        height: 48px;
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: @wenzhen;
        border-bottom: 1px solid #EEE;
      }
      .question-list{
        margin-top: 16px;
        padding-bottom: 10px;
        .qa-item{
          color: @black;
          margin-bottom: 30px;
          .question{
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
          }
          .answer{
            margin-top: 20px;
            font-size: 14px;
            line-height: 14px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      formData: {
        type: Object,
        default: {
          create_time: 0,
          pat_username: '测试患者',
        }
      }
    },
    data() {
      return {
        previewShow: false,
        previewImageList: [],
        imageIndex: 0
      }
    },
    methods: {
      previewImage(list,index) {
        this.imageIndex = index;
        this.previewShow = true;
        this.previewImageList = list;
      }
    },
    filters: {
      dateFilter(value) {
        return moment.unix(value).format('YYYY.MM.DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/firstRecord.vue